import React from 'react';
import { Image, Overlay } from '@thd-olt-component-react/core-ui';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

const PortfolioImageOverlay = ({ imgSrc, onClose }) => {

  if (!imgSrc) {
    return null;
  }

  return (
    <Overlay
      open
      onClose={onClose}
      modalClass="p2p-overlay"
    >
      <button
        tabIndex={-1}
        aria-label="close"
        data-testid="image-overlay-close"
        className="p2p-portfolio__overlay-close-button"
        onClick={onClose}
      >
        <CloseIcon style={{ fontSize: '5rem' }} />
      </button>
      <div className="p2p-portfolio__overlay-image-container">
        <Image
          src={imgSrc}
          lazy
          className="p2p-portfolio__overlay-image-content"
          alt="portfolio project overlay image"
        />
      </div>
    </Overlay>
  );
};

export default PortfolioImageOverlay;

PortfolioImageOverlay.propTypes = {
  imgSrc: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

PortfolioImageOverlay.defaultProps = {
  imgSrc: ''
};
